import React, { useState } from "react";
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";
import Tabs from "./components/Tabs/Tabs";
import OverviewTab from "./components/OverviewTab/OverviewTab";
import ExpensesTab from "./components/ExpensesTab/ExpensesTab";
import RevenueTab from "./components/Revenue/RevenueTab";
import styles from "./Accounting.module.css";
import { OverviewIcon, ExpensesIcon, RevenueIcon, CapitalIcon, SupplierIcon } from "../../Component/Shared/Icon/Icon";
import CapitalTab from "./components/CapitalTab/CapitalTab";
import SupplierTab from "./components/SupplierTab/SupplierTab";

const TABS = [
  { key: "overview", label: "نظرة عامة", icon: <OverviewIcon /> },
  { key: "expenses", label: "المصروفات", icon: <ExpensesIcon /> },
  { key: "revenue",  label: "الإيرادات",   icon: <RevenueIcon /> },
  { key: "capital",  label: "رأس المال",  icon: <CapitalIcon /> },
   { key: "suppliers", label: "الموردين", icon: <SupplierIcon /> },
];

const Accounting = () => {
  const [activeTab, setActiveTab] = useState("overview");

  const renderTab = () => {
    switch (activeTab) {
      case "overview":
        return <OverviewTab />;
      case "expenses":
        return <ExpensesTab />;
      case "revenue":
        return <RevenueTab />;
      case "capital":
        return <CapitalTab />;
      case "suppliers":
        return <SupplierTab />;
      default:
        return null;
    }
  };

  return (
    <div className="apDiv ChatApp">
      <Sidebar />
      <div className="body_container container" dir="rtl">
        <div className="Header">
          <Header />
        </div>

        <div className={styles.pageContent}>
          <Tabs tabs={TABS} activeTab={activeTab} onChange={setActiveTab} />
          {renderTab()}
        </div>
      </div>
    </div>
  );
};

export default Accounting;